<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				待开票任务列表
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-no-more-click  v-if="$hasPermission('plat:platticketrecord:update')" type="primary" size="small" @click="plkpAll()">批量合并开票</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platinvoicingtasklist:export')" type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item><el-button type="info" @click="getDataList()">刷新</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__platticketrecord">
			<div class="search-form-area">
				<el-form :model="dataForm" style="padding-top:10px;" :label-width="'110px'" ref="loginFormRef" @keyup.enter.native="getDataList()">
					<el-row>
						<el-col :md="8" :lg="8">
							<el-form-item label="结算主体名称:" prop="publishName"><el-input style="width: 95%;" v-model="dataForm.publishName" placeholder="结算主体名称" clearable></el-input></el-form-item>
						</el-col>
						<el-col :md="8" :lg="8">
							<el-form-item label="结算单编号:" prop="dealCode"><el-input style="width: 95%;" v-model="dataForm.dealCode" placeholder="结算单编号" clearable></el-input></el-form-item>
						</el-col>

						<!-- <el-col :md="8" :lg="8">
							<el-form-item label="企业名称:" >
								<el-input style="width: 95%;" v-model="dataForm.dealBody" placeholder="企业名称" clearable>
								</el-input>
							</el-form-item>
						</el-col> -->
						<el-col :md="8" :lg="8">
							<el-form-item label="税源地:" prop="bodyId">
								<el-select style="width: 95%;" v-model="dataForm.bodyId" placeholder="请选择" clearable filterable>
								<el-option
									v-for="item in bodyPageList"
									:key="item.id"
									:label="`${item.bodyName}-${item.abbreviation}`"
									:value="item.id">
								</el-option>
								</el-select>
							</el-form-item>
						  </el-col>
						<el-col :md="12" :lg="10">
							<el-form-item label="支付时间:" >
								<el-date-picker
										style="width: 48%"
										v-model="dataForm.startDate"
										placeholder="开始时间"
										type="date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
								></el-date-picker>
								<span style="width:4%;text-align: center;display: inline-block;">~</span>
								<el-date-picker
										style="width: 48%"
										v-model="dataForm.endDate"
										placeholder="结束时间"
										type="date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
								></el-date-picker>
							</el-form-item>
						</el-col>

						<el-col :md="8" :lg="14">
							<el-form-item :label-width="'20px'" style="text-align:right;margin-right:20px;">
								<el-button type="primary" @click="getDataList()">查询</el-button>
								<el-button type="info" @click="resetLoginForm">重置</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div class="table-container">
				<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
					<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
					<el-table-column label="序号" type="index" width="50" align="center">
						<template slot-scope="scope">
							<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<!--<el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
					<!-- <el-table-column prop="dealCode" width="200" label="结算单编号" header-align="center" align="center">
						<template slot-scope="scope">
							<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="taskinfoHandle(scope.row.id)">{{scope.row.dealCode}}</el-button>
						</template>
					</el-table-column> -->
					<el-table-column prop="dealCode" label="结算单编号" header-align="center" align="center">
						<!-- <template slot-scope="scope">
                    	<el-button type="text" class="el_hover_dectrion" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
                	</template> -->
					</el-table-column>
					<el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>

					<el-table-column prop="taskCode" label="任务编号" header-align="center" align="center">
						<template slot-scope="scope">
                    	<el-button type="text" class="el_hover_dectrion" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
                	</template>
					</el-table-column>
					<el-table-column prop="taskTypeName" label="任务大类" header-align="center" align="center">
						<template slot-scope="scope">
							<span>{{scope.row.taskTypeName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="dealBody" label="结算主体名称" header-align="center" align="center"></el-table-column>
					<el-table-column prop="bodyName" label="我方主体名称" header-align="center" align="center"></el-table-column>
					<el-table-column label="结算金额（元）" header-align="center" align="center">
						<template slot-scope="scope">
							<span>{{(scope.row.money).toFixed(2)}}</span>
					  </template>
					</el-table-column>
					<el-table-column prop="currency" label="币种" header-align="center" align="center"></el-table-column>
					<el-table-column prop="paymentDate" label="支付时间" header-align="center" align="center"></el-table-column>
					<el-table-column :label="$t('handle')" v-if="$hasPermission('plat:platinvoicingtasklist:info')" fixed="right" header-align="center" align="center" width="150">
					  <template slot-scope="scope">
						<el-button v-no-more-click  v-if="$hasPermission('plat:platticketrecord:update')" type="text" size="small" @click="childHandle(scope.row)">申请开票</el-button>
					  </template>
					</el-table-column>
				</el-table>
				<el-pagination
					background
					:current-page="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="limit"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
					@size-change="pageSizeChangeHandle"
					@current-change="pageCurrentChangeHandle"
				></el-pagination>
			</div>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platticketrecord-add-or-update'
import { addDynamicRoute } from '@/router'
import ArrayUtils from "../../../utils/ArrayUtils";

export default {
  mixins: [mixinViewModule],
  data () {
    return {
		plkflist:[],
		taskList:[],
      options: [
        {
          value: '0',
          label: '未开票'
        },
        {
          value: '1',
          label: '已开票'
        }
      ],
      value: '',
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/page-wait-ticket',
        getDataListIsPage: true,
        exportURL: '/sys/plat/task/export-wait-ticket',
		isBodyPage:true

      },
      dataForm: {
		publishName: '',
		taxCode: '',
		dealBody:'',
		startDate:'',
		endDate:'',
		bodyId:''
      }
    }
  },
  computed: {
    // dataList() {
    //   return this.dataList.map((item) => {
	// 	  console.log(item)
    //     return {
    //       ...item,
    //       ,
    //     };
    //   });
    // },
  },
  components: {
    AddOrUpdate
  },
  created(){
	  this.getDropDownData();
	  this.getDataList();
  },
  methods: {
	  //任务发布编号
            goTaskInfo(id){
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
                // 路由参数
                const routeParams = {
                    routeName: `${this.$route.name}__任务详情`,
                    title: `任务详情`,
                    path: 'plat/platttask-info',
                    params: {
                        id:id
                    }
                }
                // 动态路由
                addDynamicRoute(routeParams, this.$router)
            },
	  handleTaskType(type){
		  console.log(type)
		  return  ArrayUtils.getItemBy(
            this.taskList,
            "dictValue",
            type
          ).dictLabel
	  },
	  //            任务大类请求
    getDropDownData() {
      this.$http
        .get(
          "sys/dict/data/page?page=1&limit=1000&dictTypeId=1289513229072973825"
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.taskList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 点击重置按钮，重置登陆表单
    // 1.在表单中引入ref="loginFormRef"属性，loginFormRef值可以自定义；
    // 2.给重置按钮绑定点击事件：@click="resetLoginForm"；
    // 3.实现点击事件触发的方法，得到引入的属性值对象，调用resetFields方法，即：this.$refs.loginFormRef.resetFields()
    resetLoginForm () {
        this.dataForm.publishName =  '';
        this.dataForm.taxCode =  '';
        this.dataForm.dealBody =  '';
        this.dataForm.dealCode =  '';
        this.dataForm.startDate =  '';
        this.dataForm.endDate =  '';
        this.dataForm.bodyId =  '';
      	this.getDataList()
    },
	dataListSelectionChangeHandle(val){
		this.plkflist = val.map(item => item.dealApprovalId)
	},
	plkpAll(){
		if(this.plkflist.length == 0){
			this.$message({
				showClose:true,
				type:'warning',
				message: "请至少选择一条数据进行批量开票",
			})
			return false
		}
		localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
		// 路由参数
		const routeParams = {
			routeName: `${this.$route.name}__申请发票`,
			title: `申请发票`,
			path: 'plat/platinvoicingtasklist-add',
			params: {
			id: this.plkflist
			}
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
	},
    childHandle (row) {
		console.log(row)
		// if (!row.finishProofPath2) {
		// 	this.$message({
		// 		showClose:true,
		// 		type:'warning',
		// 		message: "该结算单未上传业务确认及服务成果验收单，请联系客服或前往结算申请上传。",
		// 	})
		// 	return false
		// }
		localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
		// 路由参数
		const routeParams = {
			routeName: `${this.$route.name}__申请发票`,
			title: `申请发票`,
			path: 'plat/platinvoicingtasklist-add',
			params: {
			id: [row.dealApprovalId]
			}
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },
    taskinfoHandle (id) {
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
      const routeParams = {
        routeName: `${this.$route.name}__任务详情`,
        title: `任务详情`,
        path: 'plat/platbill-details',
        params: {
          id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>

<style>
.mod-plat__platticketrecord {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);

  .search-form-area {
    flex-shrink: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;

    .el-table {
      flex: 1;
      /* overflow: auto; */
    }

    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>